import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
app.initializers.add('val-ui-post-user-rank-badge', () => {
  extend(PostUser.prototype, 'view', function (vnode) {
    const post = this.attrs?.post;
    const user = post?.user?.();
    if (!user || !vnode) return;
    const groups = user.groups?.() || [];

    // Groupe visible le plus élevé.
    //
    // 1     Administrateur
    // 4     Modérateur
    // 5     Membre d'honneur
    // 6 / 9 Membre régulier
    // 7 / 8 Membre débutant
    // 3     Member
    const priority = [1, 4, 5, 6, 9, 7, 8, 3];
    let rankGroup = null;
    for (const id of priority) {
      rankGroup = groups.find(g => Number(g.id()) === id);
      if (rankGroup) break;
    }
    const rankColor = rankGroup?.color?.() || null;
    const primaryName = String(user.attribute('primaryBadgeName') || '').trim().toLowerCase();
    const rankNames = new Set(['member', 'membre débutant', 'membre régulier', "membre d'honneur"]);

    /*
     * Couleur du badge FoF près du pseudo.
     */
    let badgeBg = user.attribute('valPrimaryBadgeBackgroundColor');
    let badgeFg = user.attribute('valPrimaryBadgeIconColor');

    // Si le badge FoF est un rang, même couleur que le groupe.
    if (rankNames.has(primaryName) && rankColor) {
      badgeBg = rankColor;
      badgeFg = '#fff';
    }
    vnode.attrs = vnode.attrs || {};
    const oldStyle = vnode.attrs.style && typeof vnode.attrs.style === 'object' ? vnode.attrs.style : {};
    vnode.attrs.style = {
      ...oldStyle,
      ...(badgeBg ? {
        '--val-primary-badge-bg': badgeBg
      } : {}),
      ...(badgeFg ? {
        '--val-primary-badge-fg': badgeFg
      } : {})
    };

    /*
     * Si le badge FoF principal est lui-même un rang,
     * on le masque : le badge VAL ci-dessous représentera
     * le véritable groupe prioritaire (Admin, Modo, etc.).
     *
     * Les badges distinctifs FoF (Donateur...) restent visibles.
     */
    if (rankNames.has(primaryName)) {
      const oldClass = String(vnode.attrs.className || '').trim();
      vnode.attrs.className = (oldClass + ' ValPostUser--hidePrimaryRank').trim();
    }
    if (!rankGroup) return;
    const icon = rankGroup.icon?.() || 'fas fa-user';
    const name = rankGroup.nameSingular?.() || '';
    if (!Array.isArray(vnode.children)) {
      vnode.children = vnode.children ? [vnode.children] : [];
    }
    vnode.children.push(m('span.ValPostUserRankBadge', {
      title: name,
      style: {
        '--val-post-rank-color': rankColor || 'var(--muted-color)'
      }
    }, [m('i', {
      className: icon
    })]));
  });
});